import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/database'
const config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
};

firebase.initializeApp(config);
const db = firebase.firestore()
const auth = firebase.auth()
if (location.hostname === "localhost") {
    // db.settings({
    //     host: "localhost:5003",
    //     ssl: false
    // });
    // firebase.functions().useFunctionsEmulator("http://localhost:5001");
}
const fieldTypes = firebase.firestore.FieldValue;

export {
    firebase,
    db,
    auth,
    fieldTypes
}
